import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Api from "../services/globalBibleApi";
import AppBuildModal from "../components/AppBuildModal";
import Table from "../components/Table";
import BreadCrumbs from "../components/BreadCrumbs";
import Badge from "../components/Badge";

const buildSiteLink = (site) =>
  site.customDomain
    ? `http://${site.customDomain}`
    : `http://${site.subdomain}.global.bible`;

const Sites = () => {
  const [sites, setSites] = useState();
  const [selectedSite, setSelectedSite] = useState(null);

  useEffect(() => {
    Api.listSites()
      .then((siteList) => {
        const sortedSiteList = siteList.sort((a, b) => {
          const aSiteLink = buildSiteLink(a);
          const bSiteLink = buildSiteLink(b);
          if (aSiteLink < bSiteLink) return -1;
          if (aSiteLink > bSiteLink) return 1;
          return 0;
        });

        setSites(sortedSiteList);
      })
      .catch((err) => {
        console.error(err);
        // TODO: setError("Error fetching sites");
      });
  }, []);

  return (
    <div>
      <BreadCrumbs
        title="Sites List"
        actions={
          <span className="inline-flex rounded-md shadow-sm">
            <Link
              to="/sites/new"
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm hover:no-underline leading-5 font-medium rounded-md text-white bg-blue-600 hover:bg-blue-500 focus:outline-none focus:border-blue-700 focus:shadow-outline-blue active:bg-blue-700 transition ease-in-out duration-150"
            >
              New Site
            </Link>
          </span>
        }
        paths={[{ title: "Sites", link: "/sites" }]}
      />
      <Table
        className="w-full"
        headers={["Site Title", "Link", "Status", "Actions"]}
        loading={!sites && !Array.isArray(sites)}
        rows={(sites || []).map((site) => {
          const siteLink = buildSiteLink(site);
          return {
            key: site.title,
            row: [
              <>
                <div
                  alt={`${site.title} favicon`}
                  className="inline-block w-5 h-5 -mb-1 mr-2 bg-gray-100 rounded"
                  style={{
                    background: `url(${siteLink}/site-assets/icons/favicon-96x96.png) center / cover`,
                  }}
                />
                <Link
                  className="font-bold"
                  to={`sites/${site.id}`}
                  href={`sites/${site.id}`}
                >
                  {site.title}
                </Link>
              </>,
              <a href={siteLink} target="_blank" rel="noopener noreferrer">
                {siteLink}
              </a>,
              <Badge type={site.published ? "primary" : "warning"}>
                {site.published ? "Published" : "Draft"}
              </Badge>,
              <span className="inline-flex rounded-md shadow-sm">
                <button
                  type="button"
                  className="inline-flex items-center px-2.5 py-1.5 border border-transparent text-xs leading-4 font-medium rounded text-white bg-blue-600 hover:bg-blue-500 focus:outline-none focus:border-blue-700 focus:shadow-outline-blue active:bg-blue-700 transition ease-in-out duration-150"
                  onClick={() => setSelectedSite(site)}
                >
                  Build App
                </button>
              </span>,
            ],
          };
        })}
      />
      <AppBuildModal
        show={!!selectedSite}
        toggleModal={() => setSelectedSite(null)}
        title={`Build App: ${selectedSite ? selectedSite.subdomain : ""}`}
        subdomain={selectedSite?.subdomain ?? ""}
      />
    </div>
  );
};

export default Sites;
